import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { GetService } from '../dataservice/get.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LanguageService } from '../dataservice/language.service';

/**
 * Language constant import.
 */
import {LANGUAGE_TYPE} from '../constant/app.constant';

@Component({
  selector: 'app-web-share',
  templateUrl: './web-share.component.html',
  styleUrls: ['./web-share.component.css']
})
export class WebShareComponent implements OnInit {
  lang_value: any = 'English';
  selected_lang = 'en';
  show_app_strip = false;
  show_app_dropdown = false;
  referID: any;
  productType: any;
  productID: any;
  parent_product: any;
  finished = false;
  shareContent: any;
  deviceInfo: any;
  isMobile = false;
  isTablet = false;
  isDesktopDevice = false;
  content_condition: any;
  product_type_arr = {
    journal: 3,
    feed: 1,
    channel: 10,
    event: 7,
    session: 21,
    profile: 14,
    webinar: 27,
    doctalk: 24,
    pharma: 28,
    survey: 25,
    cme: 8,
    drug: 15,
    event_v3: 7,
    session_v3: 21,
    doctalkseries: 36,
    meeting: 41
  }

  public eventProductType: string;

  constructor(public mls: LanguageService, private deviceService: DeviceDetectorService, public getApiService: GetService, public router: Router, public activateRoute: ActivatedRoute) {
    this.activateRoute.params.subscribe(params => {
      //console.log(params)
      this.referID = params['referID'];
      if (this.referID == undefined) {
        this.referID = '';
      }
      this.productType = params['productType'];
      this.productID = params['productID'];
      this.parent_product = params['parent_product'];
      this.productType = this.product_type_arr[this.productType];

      this.eventProductType = params['productType'];
    })
    this.content_condition = this.activateRoute.snapshot.queryParamMap.get('con');

    this.getApiService.cmpid = this.activateRoute.snapshot.queryParamMap.get('cmpid');
    var base64Rejex = /^(?:[A-Z0-9+\/]{4})*(?:[A-Z0-9+\/]{2}==|[A-Z0-9+\/]{3}=|[A-Z0-9+\/]{4})$/i;
    var isBase64Valid = base64Rejex.test(this.content_condition); // base64Data is the base64 string

    if (isBase64Valid) {

      this.content_condition = parseInt(atob(this.content_condition));
      this.Armstrong(this.content_condition);
    }

  }

  ngOnInit() {

    if (navigator.language === LANGUAGE_TYPE.VI || localStorage.getItem('lang') === LANGUAGE_TYPE.VI) {
      localStorage.setItem('lang', LANGUAGE_TYPE.VI);
    } else if (navigator.language === LANGUAGE_TYPE.ZH || localStorage.getItem('lang') === LANGUAGE_TYPE.ZH) {
      localStorage.setItem('lang', LANGUAGE_TYPE.ZH);
    } else {
      localStorage.setItem('lang', LANGUAGE_TYPE.EN);
    }


    if (localStorage.getItem('lang') != null) {
      this.selected_lang = localStorage.getItem('lang')

    }
    else {
      this.selected_lang = 'en';
    }


    if (localStorage.getItem('lang') == 'en') { this.lang_value = 'English'; }
    else if (localStorage.getItem('lang') == 'vi') { this.lang_value = 'Vietnamese'; }
    else if (localStorage.getItem('lang') == 'zh') { this.lang_value = 'Mandarin'; }




    if (sessionStorage.getItem('show_app_strip') != null) {
      this.show_app_strip = false;
    }
    else {
      this.show_app_strip = true;
    }

    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
    //   console.log(this.deviceInfo);
    // console.log(isMobile);  // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    // console.log(isTablet);  // returns if the device us a tablet (iPad etc)
    // console.log(isDesktopDevice); // returns if the app is running on a
  }


  // contentSetailShare()
  // {
  //     this.finished=false;
  //     this.getApiService.getContentShare(this.productType,this.productID,this.referID).subscribe(data=>{
  //     this.finished=true;
  //     if(data.status==1)
  //         {
  //          this.shareContent=data.data.mix_list[0];

  //         } // condition closed
  //         else if(data.status==0)
  //         {
  //     //    this.fcs.errorHandeler(data);
  //         }
  //       })
  // }

  resData(data) {
    // console.log(data);
  }

  hide_app_strip() {
    sessionStorage.setItem('show_app_strip', 'false');
    this.show_app_strip = false;
  }


  installApp() {
    if (this.deviceInfo.os == 'iOS') {
      window.open('https://itunes.apple.com/us/app/docquity/id1048947290?mt=8', '_blank');
    } else if (this.deviceInfo.os == 'Android') {
      window.open('https://play.google.com/store/apps/details?id=com.virinchi.mychat', '_blank');
    } else {
      //window.open('https://docquity.com/','_blank');
      this.getApiService.navigateToSection(this.productType, this.productID);
      sessionStorage.setItem('show_app_strip', 'false');
      this.show_app_strip = false;
    }
  }


  Armstrong(number) {
    var flag, remainder, addition = 0;

    flag = number;
    while (number > 0) {
      remainder = number % 10;
      addition = addition + remainder * remainder * remainder;
      number = Math.floor(number / 10);
    }

    if (addition == flag) {
      this.content_condition = 1;
      // window.alert("-The inputed number is Armstrong");
    }
    else {
      this.content_condition = 0;
      // window.alert("-The inputed number is not Armstrong");
    }
  }


  //select language
  selectLang(val) {
    localStorage.setItem('lang', val);
    if (val == 'en') {
      this.lang_value = 'English';
      this.selected_lang = 'en';
    } else if (val == 'in') {
      this.lang_value = 'Bahasa';
      this.selected_lang = 'in';
    } else if (val == 'vi') {
      this.lang_value = 'Vietnamese';
      this.selected_lang = 'vi';
    } else if (val == 'zh') {
      this.lang_value = 'Mandarin';
      this.selected_lang = 'zh';
    }

    window.location.reload();

    // this.multiLangService.setLanguage(val);

  }


}
